<template>
  <div class="api">
    <div id="logoAndNav" class="container fade pt-5 show active">
      <div class="row">
        <!-- Sticky sidebar -->
        <div id="stickyBlockStartPoint" class="col-lg-2 pr-xl-5 mb-5 mb-lg-0">
          <!-- Filter -->
          <div>
            <div class="navbar-expand-lg navbar-expand-lg-collapse-block">
              <!-- Responsive Toggle Button -->
              <button v-b-toggle.providerBrandedApiSidebarNav class="navbar-toggler btn btn-block border py-3" aria-label="Toggle navigation">
                <span class="d-flex justify-content-between align-items-center">
                  <span class="h5 mb-0">{{ $t('M05b-1-07-mobile') }}</span>
                  <span class="navbar-toggler-default">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z" />
                    </svg>
                  </span>
                  <span class="navbar-toggler-toggled">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z" />
                    </svg>
                  </span>
                </span>
              </button>
              <!-- End Responsive Toggle Button -->
              <b-collapse id="providerBrandedApiSidebarNav" class="navbar-collapse">
                <div class="mt-5 mt-lg-0">
                  <h2 class="h4">{{ $t('M05b-1-07') }}</h2>
                  <!-- Nav Link -->
                  <div class="api-group-container">
                    <a
                      v-for="apiGroup in apiGroups"
                      :key="`${apiGroup}-${Date.now()}`"
                      class="dropdown-item d-flex justify-content-between align-items-center px-0 filter"
                      :class="currentGroup === apiGroup ? `theme-link` : ''"
                      @click="filterCards(apiGroup)"
                    >
                      <span class="text-truncate-8-block">{{ apiGroup }}</span>
                    </a>
                  </div>
                  <!-- End Nav Link -->
                </div>
              </b-collapse>
            </div>
          </div>
          <!-- End Filter -->
        </div>
        <!-- End Sticky Sidebar -->

        <!-- Main Partners List Section -->
        <div id="scroll-to-div" class="col-lg-10 mb-5 mb-lg-0">
          <!-- ===== Partners ===== -->
          <div class="space-bottom-1">
            <!-- <h3 v-if="providerInfo && providerInfo[0] && providerInfo[0].display_name" class="mb-5 px-1">{{ providerInfo[0].display_name }} {{ $t('M05b-1-02') }} {{ currentGroup !== 'All' ? currentGroup : $t('M05b-1-03') }}</h3> -->
            <div class="mb-5 px-1">
              <form class="input-group input-group-merge" onsubmit="return false;">
                <input ref="searchKeywordInput" v-model="searchKey" type="search" class="form-control" :placeholder="`${$t('CC06-02-01')} ${$t('M06a-05b')}`" :aria-label="`${$t('CC06-02-01')} ${$t('M06a-05b')}`" aria-describedby="searchAPIs" @input="searchApi">
                <div class="input-group-append">
                  <span id="searchAPI" class="input-group-text">
                    <i class="fas fa-search" />
                  </span>
                </div>
              </form>
            </div>
            <!-- Card Items -->
            <div v-if="!loading" class="row">
              <div v-for="api in visibleCard" :key="api.name" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                <ApiCardBranded
                  :item="api"
                  :clickHandler="goToApiInfo"
                  :fromApiCarousel="false"
                  :fromProvider="true"
                  :loading="!apiCardLoaded"
                  afterLogin="apiReadmeBranded"
                />
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 mb-5">
                <InfoCard
                  :to="{ type: 'link', link: getEditableInfo('user_guide', 'why-cant-i-see-my-partners-api') }"
                  title="CC05-3-02"
                  description="CC05-3-03"
                  :showDeveloperInfo="false"
                  :withDeveloperInfo="false"
                />
              </div>
            </div>
            <!-- End Card Items  -->
          </div>
          <!-- ===== Partners ===== -->

          <div v-if="noOfAPIs === 0 && searchKey!=='' && apiCardLoaded && showNotFound" class="result-container">
            <div class="space-1" />
            {{ $t('err-general-01-01', { key: searchKey }) }}
            <div class="space-1" />
          </div>

          <div v-if="noOfAPIs === 0 && searchKey==='' && apiCardLoaded && showNotFound" class="text-center">
            <img class="w-lg-40 w-50" src="@/assets/svg/illustrations/empty.svg">
            <p>Sorry, you don't have API in this API group currently.</p>
            <span class="d-block mt-5">
              <router-link class="theme-button btn btn-primary btn-wide text-white" to="/use-cases">{{ $t('M09a-03') }}</router-link>
            </span>
          </div>
          <!-- === Pagination -->
          <div v-if="(noOfAPIs > 0 || !showNotFound)" aria-label="Page navigation example">
            <Pagination
              :page="currentPage"
              :page-number="Math.ceil(noOfAPIs/pageSize) || 1"
              :page-change-handler="handleCurrentChange"
            />
          </div>
          <!-- === End Pagination -->

        </div>
      </div>
      <!-- End Main API List Section -->

      <!-- Sticky Block End Point -->
      <div id="stickyBlockEndPoint" />

      <div class="space-top-2" />

    </div>
  </div>
</template>

<script>
const $ = require('jquery')
import ApiCardBranded from '@/components/api-card-branded'
import InfoCard from '@/components/info-card'
import Pagination from '@/components/pagination'
import HSStickyBlock from '@/assets/vendor/hs-sticky-block/src/js/hs-sticky-block'
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
import providerInfoMixin from '@/mixins/provider-info'
import Axios from 'axios'
import _ from 'lodash'
import { searchAPI } from '@/api/profile'
import { mapGetters } from 'vuex'
import getEditableInfo from '@/utils/get-editable-info'

export default {
  name: 'ProviderInfoBrandedApi',
  components: {
    ApiCardBranded,
    InfoCard,
    Pagination
  },
  mixins: [providerInfoMixin],
  props: {
    apiGroups: {
      type: Array,
      default: () => ['All']
    },
    themeColor: {
      type: String,
      default: '#57ABF000'
    }
  },
  data() {
    return {
      showNotFound: false,
      apiCardLoaded: false,
      currentPage: 1,
      pageSize: 8,
      noOfAPIs: 0,
      visibleCard: [],
      searchKey: '',
      currentGroup: 'All',
      items: [],
      cards: [],
      previousRequest: null,
      handleSearchKeyChange: _.debounce(async function() {
        await this.cancelPreviousRequest()
      }, 200, { 'maxWait': 250 })
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.login
    },
    userProfile() {
      return this.$store.getters.userProfile
    },
    tableOffset() {
      return (this.currentPage - 1) * this.pageSize
    },
    ...mapGetters(['loading'])
  },
  watch: {
    async userProfile() {
      await this.initialise()
    },
    apiGroups: {
      deep: true,
      handler() {}
    }
  },
  async created() {
    await this.initialise()
  },
  mounted() {
    new HSStickyBlock($('.js-sticky-block')).init()
    new HSGoTo($('.js-go-to')).init()
  },
  methods: {
    async initialise() {
      // console.log('api loading true')
      this.$store.dispatch('app/setLoading', true)
      await this.getAPIListInfo()
      // console.log('api loading false')
      this.$store.dispatch('app/setLoading', false)
    },
    async cancelPreviousRequest() {
      if (this.previousRequest) {
        this.previousRequest.cancel()
        this.previousRequest = null
      }
      await this.getAPIListInfo()
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      await this.handleSearchKeyChange()
      window.scrollTo({ top: $('#scroll-to-div').offset().top - 85, left: 0, behavior: 'smooth' })
    },
    filterCards(val) {
      this.currentGroup = val
      this.searchKey = ''
      this.handleCurrentChange(1)
    },
    async getAPIListInfo() {
      this.apiCardLoaded = false
      var filter = {}
      if (this.currentGroup !== 'All') {
        filter.apiProviderGroup = this.currentGroup
      }
      if (this.searchKey !== '') {
        filter.searchKeyword = this.searchKey
      }
      if (this.providerInfo[0] && this.providerInfo[0].provider_short_id !== '') {
        filter.providerShortId = this.providerInfo[0].provider_short_id
      }
      const axiosSource = Axios.CancelToken.source()
      this.previousRequest = { cancel: axiosSource.cancel }
      await searchAPI(axiosSource.token, this.userProfile.id, this.pageSize, this.tableOffset, filter)
        .then(res => {
          const response = res['data'].map(api => {
            return {
              ...api,
              api_id: api.id,
              api_short_id: api.short_id,
              api_name: api.name,
              api_type: api.accessibility,
              api_description: api.short_description,
              api_category: api.category,
              api_no_of_calls: api.request_count,
              api_errors_percentage: api.success_rate,
              api_latency: api.average_latency,
              api_provider_group: api.groups,
              display_name: api.provider_display_name
            }
          })
          this.visibleCard = response
          this.noOfAPIs = parseInt(res.headers['content-range'].split('/')[1])
          this.apiCardLoaded = true
          this.previousRequest = null
        })
        .catch(error => {
          console.log('getAPIList error', error)
          this.apiCardLoaded = true
          this.$store.dispatch('app/setLoading', false)
          this.previousRequest = null
        })
    },
    searchApi(e) {
      this.searchKey = e.target.value
      this.handleCurrentChange(1)
    },
    goToApiInfo(item) {
      try {
        this.$router.push({
          name: 'api-info-branded',
          params: {
            provider_name: (item.display_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.provider_short_id}`)).replace(/\-+/g, '-'),
            api_name: (item.api_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.api_short_id}`)).replace(/\-+/g, '-'),
            tab_name: 'readme'
          }
        })
      } catch (err) {
        console.log('err in goToApiInfo', err)
      }
    },
    getEditableInfo(type, id, withLangCode = true) {
      return getEditableInfo(type, id, withLangCode ? this.$i18n.locale : '')
    }
  }
}
</script>
<style lang="scss" scoped>
.api-group-container {
  :not(button):hover {
    color: #57abf0;
    cursor: pointer;
  }
  .dropdown-item {
    width: 100%;
    white-space: normal;
  }
  .show-more-button {
    border-radius: 0.5rem;
  }
}
.result-container {
  display: flex;
  justify-content: center;
  font-size: 20px;
}
.none {
  display: none;
}
.filter {
  color: #505050;
}
.loading-container {
  height: 45vh;
}
</style>
